import validLicensePresent from "license/ValidLicensePresent";
const Component = () => null;
const bindings = {
  "components.upsell.wrapper": [{ useCondition: validLicensePresent, component: Component }]
};
export default bindings;
